import { Theme } from "@mui/material/styles";

export const styles = {
  modal: {
    width: "480px",
    borderRadius: "16px",
  },
  content: {
    p: 0,
  },
  qrContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: (theme: Theme) => theme.colors.blue600,
    color: (theme: Theme) => theme.colors.grey000,
    borderRadius: "8px",
    width: "100%",
    padding: "36px",
    marginBottom: "24px",
  },
  qrWrapper: {
    backgroundColor: (theme: Theme) => theme.colors.grey000,
    padding: "4px",
    borderRadius: "8px",
    height: "168px",
    width: "168px",
  },
};
